// import React, { useState } from 'react';
// import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';


const events = [
  {
    title: 'Common Sense School',
    image: '/images2/img2_files/l3112021181854253.png',
  },
  {
    title: 'Değerler Eğitimi',
    image: 'images2/img2_files/logo.jpg',
  },
  {
    title: 'Tanıtım Filmi',
    image: '/images2/img2_files/l3112021181655159.png',
  },
  {
    title: 'Su Müzesi',
    image: '/images2/img2_files/l1512019151943935.jpg',
  },
  
  {
    title: 'Santraç Turnuvası İl Birinciliği',
    image: '/images2/img2_files/l312019112640572.jpg',
  },
   {
    title: 'Eco School',
    image: '/images2/img2_files/l21201913320207.jpg',
  },
  {
    title: 'Gelişim Yeni Yıl Konseri',
    image: '/images2/img2_files/l29122018124448469.JPG',
  },
  {
    title: 'Robotik - Kodlama',
    image: '/images2/img2_files/l29122018111239212.jpg',
  },
  
];

const CARD_WIDTH = 300; // px
const GAP = 20; // px

const EtkinliklerCarousel = () => {
  const navigate = useNavigate();
  const [position, setPosition] = useState(0);
  const containerRef = useRef(null);

  const totalWidth = (CARD_WIDTH + GAP) * events.length;

  const scrollRight = () => {
    const maxScroll = totalWidth - containerRef.current.offsetWidth;
    setPosition((prev) => Math.min(prev + CARD_WIDTH + GAP, maxScroll));
  };


  const scrollLeft = () => {
    setPosition((prev) => Math.max(prev - (CARD_WIDTH + GAP), 0));
  };

  return (
    <section className="py-10 px-6 relative">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Etkinlikler</h2>

      <div className="overflow-hidden relative">
        <div
          ref={containerRef}
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${position}px)`, gap: `${GAP}px` }}
        >
          {events.map((event, index) => (
            <div
              key={index}
              onClick={() => navigate('/etkinlikler/genel')}
               className="flex-shrink-0 bg-[#a03838] rounded-lg shadow-md w-[300px] transform transition-transform duration-300 hover:scale-105 cursor-pointer"
            >
              <img
                src={event.image}
                alt={event.title}
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <div className="p-4 text-center">
                <h3 className="text-md font-semibold text-white">{event.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation */}
      <button
        onClick={scrollLeft}
        className="absolute top-1/2 left-0 -translate-y-1/2 bg-gray-100 hover:bg-gray-300 text-gray-800 px-3 py-2 rounded-full shadow z-10"
      >
        ‹
      </button>
      <button
        onClick={scrollRight}
        className="absolute top-1/2 right-0 -translate-y-1/2 bg-gray-100 hover:bg-gray-300 text-gray-800 px-3 py-2 rounded-full shadow z-10"
      >
        ›
      </button>
    </section>
  );
};


export default EtkinliklerCarousel;
